import { Loader } from "../components/loaderComponent/Loding";
import Home from "../pages/Home/Home";
import { PaymentPage } from "../pages/PaymentPage/PaymentPage";
import { StudyPackPage, } from "../pages/StudyPackPage/StudyPackPage";
import { StudypackPapersPage } from "../pages/StudyPackPage/papers/Studypackpapers";
import { StudypackRecorings } from "../pages/StudyPackPage/recordings/StudypackRecorings";
import { StudypackTutesPage } from "../pages/StudyPackPage/tutes/StudyPackTutes";
import { SubjectPDFPage } from "../pages/SubjectPage/SubjectPDFPage";
import { SubjectPage } from "../pages/SubjectPage/SubjectPage";
import { EditProfile } from "../pages/editProfile/EditProfile";
import { ProfilePage } from "../pages/profilePage/ProfilePage";
import SignInSlide from "../pages/signInSection/SignInSlide";
import SignUpSlide from "../pages/signUpPage/SignUpSlide";
import { ChemistrySection } from "../pages/subjectSection/ChemistrySection";
import { PhysicsSection } from "../pages/subjectSection/PhysicsSection";

export const routes = [
  {
    name: "home",
    element: <Home />,
    path: "/",
  },
  {
    name: "signUp",
    element: <SignUpSlide />,
    path: "/signUp",
  },
  {
    name: "signIn",
    element: <SignInSlide />,
    path: "/signIn",
  },

  {
    name: "chemistrysection",
    element: <ChemistrySection />,
    path: "/chemistrysection",
  },
  {
    name: "physicssection",
    element: <PhysicsSection />,
    path: "/physicssection",
  },
  {
    name: "subject",
    element: <SubjectPage />,
    path: "/subject",
  },
  {
    name: "subject-pdf",
    element: <SubjectPDFPage />,
    path: "/tutepage",
  },
  {
    name: "profilepage",
    element: <ProfilePage />,
    path: "/profile",
  },
  {
    name: "paymentpage",
    element: <PaymentPage />,
    path: "/paymentpage",
  },
  {
    name: "editprofile",
    element: <EditProfile />,
    path: "/editprofile",
  },
  {
    name: "loader",
    element: <Loader />,
    path: "/loader",
  },
  {
    name: "StudyPackSection",
    element: <StudyPackPage/>,
    path: "/studypacksection",
  },
  {
    name: "studypackrecords",
    element: <StudypackRecorings/>,
    path: "/studypackrecords",
  },
  {
    name: "studypacktutes",
    element: <StudypackTutesPage/>,
    path: "/studypacktutes",
  },
  {
    name: "studypackpapers",
    element: <StudypackPapersPage/>,
    path: "/studypackpapers",
  }
];
